<p-toast position="bottom-left">
</p-toast>
<div class="twofactor-wrapper twofa-login">
  <div class="column__figure">

    <h2>Multi-Factor <br>
      Authentication</h2>
    <div class="figure__icon"><img src="assets/images/multifactor.svg" alt="Manage Your Account"></div>
    <p>Manage Your Account</p>
  </div>
  <div class="column__content">
    <img src="assets/images/logo.svg" class="logo" alt="Reflecx">
    <h3>Manage your account</h3>
    <h1>Recovery code verification</h1>

    @if(!isVerified){
    <div>
      <!-- <p>Your account has been recovered successfully. All the configured channels are unlocked. You can reconfigure multi-factor authentication from My Account.</p> -->
      <div class="form-label">
        <label>Recovery Code</label>
      </div>
      <form [formGroup]="recoveryForm" (ngSubmit)="onLogin()">
        <div class="form-field">
          <div class="tf-label"><label>ENTER USER ID</label></div>
          <input type="text" formControlName="userName">
          @if(userName.invalid && (userName.dirty || userName.touched)){
          <div class="alert error-msg">
            @if(userName.errors?.['required']){
            <div>
              USER ID is required.
            </div>
            }
          </div>
          }
        </div>

        <div class="form-field">
          <div class="tf-label"><label>Recovery Code</label></div>
          <input type="text" formControlName="code">
          @if(code.invalid && (code.dirty || code.touched)){
          <div class="alert error-msg">
            @if(code.errors?.['required']){
            <div>
              Code is required.
            </div>
            }
          </div>
          }
        </div>
        <div class="form-field">
          <button [disabled]="!recoveryForm.valid">Unlock</button>
        </div>
      </form>
    </div>
    }
    @if(isVerified){
    <div class="info-msg">
      <p>
        Your account has been recovered successfully. All the configured channels are reset. You can reconfigure multi-factor authentication from My Account.
      </p>
    </div>
    }
    @if(!isVerified){
      <div class="form-field">
        <button class="secondary" (click)="onBack()">Back to Login</button>
      </div>
      }
      @if(isVerified){
        <div class="form-field">
          <button class="secondary" (click)="onBack()">Continue</button>
        </div>
        }
  </div>
</div>